import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {Util} from "../../components/Util";

export class UserList extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return '/user/list';
    }

    protected navigate(event: any) {
        event.preventDefault();
        let id = event.target.closest('tr').getAttribute('data-id');
        super.navigate(event, '/user/edit/' + id);
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const navigate = this.navigate,
            params: {} | any = this.getFormData();

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'email', defaultValue: params?.email}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'name', defaultValue: params?.name}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Select {...{
                                    id: 'status',
                                    basic: 'show-all',
                                    items: ['active', 'inactive'],
                                    defaultValue: params?.status
                                }}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Select {...{
                                    id: 'role',
                                    basic: 'show-all',
                                    items: ['admin', 'client', 'warehouse-admin'],
                                    defaultValue: params?.role
                                }}/>
                            </div>
                        </div>
                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'id:d'}/>
                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['users']}: &nbsp;
                                    {this.state.count ? this.state.count : '-'} {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="id">
                                    # <i className="bi bi-sort-down"></i>
                                </th>
                                <th className="sortable" data-sortkey="`name`">
                                    {this.dictionary.get['name']}
                                </th>
                                <th className="sortable" data-sortkey="email">{this.dictionary.get['email']}</th>
                                <th className="sortable" data-sortkey="`status`">{this.dictionary.get['status']}</th>
                                <th className="sortable" data-sortkey="`role`">{this.dictionary.get['role']}</th>
                                <th className="sortable"
                                    data-sortkey="`language`">{this.dictionary.get['language']}</th>
                                <th className="sortable" data-sortkey="created_at">
                                    {this.dictionary.get['created_at']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                let createdAt = '-';
                                if (elem.created_at) {
                                    createdAt = (new Date(elem.created_at + ' GMT')).toLocaleString();
                                }
                                return (
                                    <tr key={elem.id} data-id={elem.id} onMouseDown={navigate}>
                                        <td style={{textAlign: 'right'}}>{elem.id}</td>
                                        <td>{elem.name}</td>
                                        <td>{elem.email}</td>
                                        <td>{Util.status(elem.status, {style: {fontSize: '11px'}})}</td>
                                        <td>{elem.role}</td>
                                        <td>{elem.language}</td>
                                        <td>{createdAt}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={7}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
